export const MIN_INPUT_SIGNS = 3
